var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.353,
    height: 65.667,
    viewBox: "0 0 219.353 65.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ffd355;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.97 -133.882)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M286.651,146.036A15.368,15.368,0,1,0,302.019,161.4,15.385,15.385,0,0,0,286.651,146.036Zm8.628,15.368a8.628,8.628,0,1,1-8.628-8.628A8.637,8.637,0,0,1,295.278,161.4Z",
    transform: "translate(1.868 0.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M379.977,158.612a15.372,15.372,0,0,0-30.326,5.01,15.129,15.129,0,0,0,1.129,3.933,15.37,15.37,0,0,0,28.169,0l.144-.33h-7.866l-.069.075a8.623,8.623,0,0,1-12.592,0,8.718,8.718,0,0,1-1.99-3.477h23.467l.03-.2a15.549,15.549,0,0,0-.1-5.009Zm-23.211-.193a8.627,8.627,0,0,1,16.19,0Z",
    transform: "translate(3.561 0.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M399.808,146.083c-.387-.026-.709-.037-1.015-.037a15.248,15.248,0,0,0-8.614,2.639v-2.639h-6.748v30.726h6.748V161.908c-.009-.164-.013-.33-.013-.5s0-.334.013-.5a8.633,8.633,0,0,1,8.615-8.126,8.521,8.521,0,0,1,.973.061l.262.029V146.1Z",
    transform: "translate(4.295 0.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.927,153.5h8.844V146.29h-8.844V133.882h0a7.212,7.212,0,0,0-7.212,7.213v20.331a15.645,15.645,0,0,0,6.466,12.643,15.48,15.48,0,0,0,9.119,2.943h.471v-7.2H267.3a8.377,8.377,0,0,1-8.373-7.951Z",
    transform: "translate(1.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M336.51,165.883l-7-19.851h-7.109L315.371,166.2l-7.039-20.172H301.1l10.694,30.743h7.166L326,156.562l7.034,20.213H340.2l10.709-30.743h-7.248l-7.039,20.175Z",
    transform: "translate(2.513 0.263)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.97 133.882)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.97,146.222h12.34v-12.34A12.34,12.34,0,0,0,184.97,146.222Z",
    transform: "translate(-184.97 -133.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M221.468,133.882a12.34,12.34,0,0,0-12.34,12.34h12.34Z",
    transform: "translate(-184.447 -133.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M225.983,158.3h8.349v-12.34h-12.34l-12.34,12.34v12.34H197.31V158.3h12.34v-12.34H197.31L184.97,158.3v12.34a12.34,12.34,0,0,0,12.34,12.34h37.021v-12.34h-12.34V158.3Z",
    transform: "translate(-184.97 -133.621)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.395 189.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.346,192.705a2.69,2.69,0,0,1-1.147,1.1,4.263,4.263,0,0,1-2.023.423h-1.807v4.046h-1.635V188.3h3.442a4.342,4.342,0,0,1,1.944.394,2.739,2.739,0,0,1,1.19,1.069,2.93,2.93,0,0,1,.394,1.506A3.011,3.011,0,0,1,268.346,192.705Zm-1.779-.236a1.548,1.548,0,0,0,.46-1.2q0-1.635-1.851-1.635h-1.807v3.256h1.807A1.992,1.992,0,0,0,266.567,192.469Z",
    transform: "translate(-261.734 -188.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M284.674,196.234H280.5l-.717,2.037h-1.707l3.572-9.983h1.893l3.572,9.983h-1.721Zm-.459-1.334-1.621-4.633-1.635,4.633Z",
    transform: "translate(-261.38 -188.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M302.18,198.271l-2.295-3.987h-1.248v3.987H297V188.3h3.444a4.281,4.281,0,0,1,1.943.4,2.79,2.79,0,0,1,1.19,1.076,2.93,2.93,0,0,1,.394,1.506,2.981,2.981,0,0,1-.567,1.772,2.869,2.869,0,0,1-1.743,1.083l2.467,4.132Zm-3.543-5.293h1.808a1.893,1.893,0,0,0,1.383-.46,1.648,1.648,0,0,0,.466-1.233,1.6,1.6,0,0,0-.458-1.212,1.951,1.951,0,0,0-1.391-.437h-1.808Z",
    transform: "translate(-260.971 -188.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M320.89,188.3v1.334h-2.654v8.635H316.6v-8.635h-2.669V188.3Z",
    transform: "translate(-260.604 -188.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.111,198.271h-1.635l-4.919-7.445v7.445h-1.636v-9.983h1.636l4.919,7.43v-7.43h1.635Z",
    transform: "translate(-260.237 -188.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M351.245,189.622v2.926h3.442v1.333h-3.442v3.056h3.872v1.334h-5.508v-9.983h5.508v1.334Z",
    transform: "translate(-259.832 -188.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M370.708,198.271l-2.295-3.987h-1.247v3.987H365.53V188.3h3.442a4.278,4.278,0,0,1,1.943.4,2.776,2.776,0,0,1,1.191,1.076,2.92,2.92,0,0,1,.394,1.506,2.987,2.987,0,0,1-.566,1.772,2.878,2.878,0,0,1-1.743,1.083l2.467,4.132Zm-3.542-5.293h1.806a1.894,1.894,0,0,0,1.384-.46,1.653,1.653,0,0,0,.467-1.233,1.591,1.591,0,0,0-.46-1.212,1.948,1.948,0,0,0-1.391-.437h-1.806Z",
    transform: "translate(-259.488 -188.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M384.451,198.023a2.965,2.965,0,0,1-1.263-1,2.526,2.526,0,0,1-.459-1.506h1.75a1.574,1.574,0,0,0,.509,1.061,1.805,1.805,0,0,0,1.269.416,1.955,1.955,0,0,0,1.32-.409,1.329,1.329,0,0,0,.473-1.054,1.154,1.154,0,0,0-.294-.818,1.986,1.986,0,0,0-.73-.487,11.184,11.184,0,0,0-1.213-.373,11.342,11.342,0,0,1-1.585-.523,2.613,2.613,0,0,1-1.04-.824,2.384,2.384,0,0,1-.431-1.493,2.653,2.653,0,0,1,.431-1.506,2.744,2.744,0,0,1,1.2-.99,4.386,4.386,0,0,1,1.793-.344,3.736,3.736,0,0,1,2.373.724,2.672,2.672,0,0,1,1.027,1.987h-1.808a1.305,1.305,0,0,0-.516-.933,1.907,1.907,0,0,0-1.247-.387,1.774,1.774,0,0,0-1.148.359,1.253,1.253,0,0,0-.444,1.033,1.048,1.048,0,0,0,.28.753,1.978,1.978,0,0,0,.71.467,11.157,11.157,0,0,0,1.176.373,12.207,12.207,0,0,1,1.613.545,2.694,2.694,0,0,1,1.063.839,2.417,2.417,0,0,1,.437,1.514,2.719,2.719,0,0,1-.409,1.434,2.952,2.952,0,0,1-1.19,1.083,3.937,3.937,0,0,1-1.844.409A4.462,4.462,0,0,1,384.451,198.023Z",
    transform: "translate(-259.115 -188.175)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.081c1830566b7cfaa767c222ef7f6007.svg";
export { ForwardRef as ReactComponent };